import { getField, updateField } from "vuex-map-fields";
import * as actions from "./actions";
import mutations from "./mutations";

export default {
  namespaced: true,
  state: {
    error: "",
    isLoading: false,
    loan_officers: null,
    loan_officer_selected: {
      id: null,
      title: null,
      states: []
    }
    // [
    //  {
    //     "url": "/loan/apply",
    //     "image": "/uploads/sites/123123/public/test.jpg",
    //     "title": "Loan officer"
    //   }
    // ],
  },
  actions,
  getters: {
    getField,
  },
  mutations: {
    updateField,
    ...mutations,
  },
};
